import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useT } from "../lib/LanguageContext";

const OPTIONS = {
  fr: { flag: "🇫🇷", name: "Français" },
  en: { flag: "🇬🇧", name: "English" },
  es: { flag: "🇪🇸", name: "Español" },
  it: { flag: "🇮🇹", name: "Italiano" },
};

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, langs } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = OPTIONS[lang];

  return (
    <div ref={ref} data-testid="language-switcher" className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        data-testid="lang-trigger"
        className={`flex items-center gap-2 rounded-full border border-[#6B5CE7] bg-transparent ${
          compact ? "px-3 py-1.5" : "px-3.5 py-2"
        } hover:bg-[#6B5CE7]/10 transition-colors`}
      >
        <span className="text-lg leading-none" aria-hidden="true">{current.flag}</span>
        <ChevronDown
          size={14}
          className={`text-[#6B5CE7] transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <ul
          role="listbox"
          data-testid="lang-menu"
          className="absolute right-0 mt-2 bg-white border border-[#F5E6A3]/70 rounded-2xl shadow-xl overflow-hidden z-50"
        >
          {langs.map((code) => {
            const opt = OPTIONS[code];
            const active = code === lang;
            return (
              <li key={code}>
                <button
                  type="button"
                  role="option"
                  aria-label={opt.name}
                  aria-selected={active}
                  data-testid={`lang-${code}`}
                  onClick={() => {
                    setLang(code);
                    setOpen(false);
                  }}
                  className={`w-full flex items-center justify-center px-5 py-3 transition-colors ${
                    active ? "bg-[#FFFBEA]" : "hover:bg-[#FFFBEA]"
                  }`}
                >
                  <span className="text-2xl leading-none" aria-hidden="true">{opt.flag}</span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
